import PasswordReq from './PasswordReq';

export default PasswordReq;
